module.exports = __webpack_public_path__ + "media/assets/faria_products/MB_CHAT-d08fefcceb24ac3dca3d2d4b66bb8251f6e92504ff54d4e3c99765f8685a3428.png";